import component from "./ChangeSituation.vue"

import wrapVueComponent from "@/utils/wrapVueComponent"
const componentName = "StudentChangeSituation"

export default wrapVueComponent(componentName, component)
